const flexListStyle = {
  flexList: {
    display: 'flex'
  }
};

export default flexListStyle;
